module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/folder.6b2c72b7.svg";